import {provideZoneChangeDetection} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';
import {LicenseManager} from 'ag-grid-enterprise';
import {App} from './app/app';
import {appConfig} from './app/core/app.config';
import {environment} from './environments/environment';

LicenseManager.setLicenseKey(environment.agGridLicenseKey);

bootstrapApplication(App, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((err) => console.error(err));
